import { useSite } from './content/context';
import { EditableText } from './edit/primitives';

interface Props {
  title: string;
  /** Makes the heading editable in the admin editor. */
  onChange?: (title: string) => void;
}

const SectionHeader = ({ title, onChange }: Props) => {
  const { edit } = useSite();
  return (
    <h2 className="af-section-title">
      {edit && onChange ? <EditableText label="Section heading" value={title} onChange={onChange} /> : title}
    </h2>
  );
};

export default SectionHeader;
